/**
 * Roles do usuário logado a partir do `user_token` (sem strip de campos).
 * @returns {import("../../../../user/model/user-role.type.js").UserRole[]}
 */
export function getViewerRolesFromLocalStorage() {
  try {
    const raw = localStorage.getItem("user_token");
    const user = raw ? JSON.parse(raw) : null;
    return Array.isArray(user?.roles) ? user.roles : [];
  } catch (_error) {
    return [];
  }
}
